let ajaxReq;

$(document).ready(function () {
    $('#faqTabList li:first a').addClass('active');
    $('#myFaqContent div:first').addClass('show active');
    $("#myFaqContent .active").find('.card:first .card-header').removeClass('collapsed');
});

/* function execute on keyup in search box */
$("#js-searchBox").keyup(function () {
    let search_data = $('#js-searchBox').val(),
        active_type = $('#faqTabList li a.active').attr('data-type');
        faqSearch(search_data, active_type);

});

/*tab switching in faq page */
$('#faqTabList li a').on('click', function () {

    let search_data = $('#js-searchBox').val(),
        active_type = $(this).attr('data-type');

    // selected_tab = $(this).attr('href');
    // $('#myFaqContent .card-header a').addClass('collapsed');
    // $('#myFaqContent .collapse ').removeClass('show');
    // $(selected_tab).find('.card:first .card-header a').removeClass('collapsed');
    // $(selected_tab).find('.card:first .collapse ').addClass('show');

    // search data in active tab
    if (search_data && search_data.length > 2) {
        faqSearch(search_data, active_type);
    }
});

/*faq search */
function faqSearch(search_data, active_type) {
    let tab_id = active_type.toLowerCase();

    if (ajaxReq != null) {
        ajaxReq.abort();
    }

    ajaxReq = $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        url: ajax_url,
        type: 'POST',
        data: {
            term: search_data,
            section: active_type
        },
        dataType: 'JSON',
        success: function (response) {
            let html_data = '',
                counter = 1,
                accordion = $('#' + tab_id).find('.accordion'),
                parent_id = accordion.attr('id'),
                head_counter = accordion.attr('data-counter');
            $.each(response.data, function (index, value) {
                html_data += '<div class="card">';
                html_data += '<div class="card-header" id="faqhead-' + head_counter + '-' + counter + '">';
                html_data += '<a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq-' + head_counter + '-' + counter + '" aria-expanded="true" aria-controls="1">' + value.title + '</a>';
                html_data += '</div>';
                html_data += '<div id="faq-' + head_counter + '-' + counter + '" class="collapse" aria-labelledby="faqhead-' + head_counter + '-' + counter + '" data-parent="#' + parent_id + '">';
                html_data += '<div class="card-body">' + value.content + '</div>';
                html_data += '</div></div>';
                counter++;
            });
            $('#' + tab_id).find('.accordion').html(html_data);
        },
        error: function (error) {
            var err = JSON.parse(error.responseText);
            $('#' + tab_id).find('.accordion').html('<strong>' + err.message + '</strong>');
        }
    });
}
